"use client"

import { ReactElement, useState } from "react"

export type FaqItem = {
  question: string
  answer: string
}

// As 4 perguntas reais da produção (§D), texto integral. O mockup tinha 7 (extras
// fabricadas) — produção ganha.
// Exportado (Story 10.7): o `/suporte/` reusa estes MESMOS itens (fonte única, sem duplicar Q&A).
export const FAQ_ITEMS: FaqItem[] = [
  {
    question: "Como funciona um VPS Forex?",
    answer:
      "Um servidor virtual privado é um computador virtual dedicado (ou um servidor dedicado) que você pode alugar para manter suas atividades de negociação funcionando continuamente sem interrupção. Ao contrário de um computador doméstico comum, um VPS Forex é alojado em um data center, fornecendo internet de alta velocidade e proteção contra quedas de energia. Esta configuração garante que sua plataforma de negociação permaneça ativa e confiável, mesmo se você tiver interrupções de internet local ou de energia.",
  },
  {
    question: "Qual é o plano certo para mim?",
    answer:
      "A escolha do plano Forex VPS certo depende da sua configuração. Aqui está um guia: VPS Essencial: Ideal apenas para testes de estratégias em 1 metatrader. VPS Básico a Ultra: Ideal para testes e contas reais de acordo com a quantidade de metatraders e o desempenho preferido. VPS Conta Financiada Básico e Pro: Ideal para traders que operam em contas financiadas onde tem necessidade de ip fixo para cumprimento das regras. Escolha de acordo com a quantidade de Metatraders. Como um provedor confiável de VPS Forex, oferecemos servidores virtuais privados rápidos e seguros, adequados para negociação em MT4, MT5 e outras plataformas.",
  },
  {
    question:
      "Quais dispositivos posso usar para acessar meu VPS de negociação?",
    answer:
      "Você pode se conectar facilmente aos seus servidores Forex VPS usando dispositivos Windows, Mac, iOS e Android. Qualquer outra dúvida, pergunte à nossa equipe de suporte.",
  },
  {
    question: "Quais são os métodos de pagamento disponíveis?",
    answer:
      "Cartões Visa e Mastercard e métodos de pagamentos locais via PayPal. PIX exclusivamente para clientes que pagarem em REAL (BRL).",
  },
]

export default function Faq(): ReactElement {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  return (
    <section
      id="faq"
      className="content-container flex scroll-mt-20 flex-col gap-10 py-16"
    >
      <header className="flex flex-col items-center gap-3 text-center">
        <span className="text-xs font-bold uppercase tracking-[1px] text-accent">
          FAQ
        </span>
        <h2 className="text-3xl font-extrabold tracking-tight text-text sm:text-4xl">
          Tem alguma dúvida?
        </h2>
      </header>
      <ul className="mx-auto flex w-full max-w-3xl flex-col gap-3">
        {FAQ_ITEMS.map((item, index) => {
          const isOpen = openIndex === index
          const panelId = `faq-panel-${index}`
          const buttonId = `faq-button-${index}`

          return (
            <li
              key={item.question}
              className="overflow-hidden rounded-[12px] border border-white/[0.07] bg-white/[0.03]"
            >
              <h3>
                <button
                  id={buttonId}
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-base font-semibold text-text transition-colors hover:text-accent"
                >
                  <span>{item.question}</span>
                  <span
                    aria-hidden="true"
                    className={`shrink-0 text-2xl leading-none text-accent transition-transform duration-200 ${
                      isOpen ? "rotate-45" : ""
                    }`}
                  >
                    +
                  </span>
                </button>
              </h3>
              <div
                id={panelId}
                role="region"
                aria-labelledby={buttonId}
                hidden={!isOpen}
                className="px-5 pb-5 text-sm leading-relaxed text-subtle"
              >
                {item.answer}
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
